// import {Platform} from 'react-native';

export const testID = id => {
  return {'data-testid': id};
  // Platform.OS === 'android' ? {accessible: true, accessibilityLabel: id} : {'data-testid': id};
};
